import React from 'react';
import {EfaLogo} from '../../assets/Logos/EfaLogo';
import './Header.scss';
import {Link} from 'react-router-dom';
import MainMenu from '../MainMenu/MainMenu';
import Grid from '@mui/material/Grid';
import {useAuthContext} from '../../services/AuthContext';
import {environmentService} from '../../infrastructure/EnvironmentService';

const Header = () => {

  const authContext = useAuthContext();
  const environment = environmentService.getEnvironment();

  return (
    <div className='header'>
      <Grid
        container
        sx={{
          width: '100%',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
        direction='row'
        wrap='nowrap'
        spacing={0}
        columns={2}
      >
        <Grid size={authContext.userAuthenticated ? { xs: 2 } : undefined}>
          <Link to='/'>
            <EfaLogo environment={environment}/>
          </Link>
        </Grid>
        {authContext.userAuthenticated && (
          <Grid size={{xs: 8}}>
            <MainMenu data-testid='header--menu'/>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default Header;
